export enum DiscountTypeEnum{
    PERCENTAGE = "PERCENTAGE",
    AMOUNT = "AMOUNT"
}

export const DiscountTypeEnumMapping: Record<DiscountTypeEnum, string> = {
    [DiscountTypeEnum.PERCENTAGE]: "enumMapping.promotionCode.PERCENTAGE",
    [DiscountTypeEnum.AMOUNT]: "enumMapping.promotionCode.AMOUNT",
  };